export type Department = {
  id: number;
  displayValue: string;
  departmentName: string;
  departmentShortName: string;
  hasSubordinateGroups: boolean;
  orderBy: number;
};

export type RequesterCostCenter = {
  id: number;
  displayValue: string;
};

export type DepartmentStatus = {
  id: number;
  displayValue: string;
  status: string;
  departmentId: number;
  departmentName: string;
  orderBy: number;
};

export type GroupedStatusType = {
  id: number;
  displayValue: string;
  orderBy: number;
  departmentStatuses: DepartmentStatus[];
};

export type DepartmentBusinessImpact = {
  retired: boolean;
  helpText: string | null;
  departmentId: number;
  departmentName: string;
  id: number;
  displayValue: string;
  name: string;
  description: string;
  orderBy: number;
};

export type GroupedBusinessImpact = {
  id: number;
  displayValue: string;
  orderBy: number;
  departmentBusinessImpacts: DepartmentBusinessImpact[];
};

export type TeamDashboardFilterEnums = {
  depts: Department[];
  requesterCostCenters: RequesterCostCenter[];
  groupedStatusTypes: GroupedStatusType[];
  groupedBusinessImpacts: GroupedBusinessImpact[];
};

export type SubmitTeamDashboardQueryPayload = {
  depts: number[] | undefined;
  requesterCostCenterNumbers: number[] | undefined;
  statusTypes: number[] | undefined;
  businessImpacts: number[] | undefined;
  hasSubscriptions: boolean | undefined;
};

export type TeamDashboardQueryResponse = {
  totalRequestCount: number;
  requestStatistics: RequestStatistic[];
  requestStatisticsByDepartment: RequestStatisticByDepartment[];
};
export type RequestStatistic = {
  statusId: number;
  statusName: string;
  orderBy: number;
  requestCount: number;
  percentage: number;
};

export type RequestStatisticByDepartment = {
  departmentId: number;
  departmentName: string;
  requestCount: number;
  requestStatistic: RequestStatistic[];
};

export enum DashboardRequestStatus {
  InProgress = 1,
  InQueue = 2,
  OnHold = 3,
  Completed = 4
}
